module.exports = __webpack_public_path__ + "img/privilege.a1a82a46.png";